import axios, { AxiosInstance } from 'axios'

import { RequestOptions } from '../../types/interfaces'
import { getAuthorizationHeader } from './authHeader'

class RequestClient {
  private axiosInstance: AxiosInstance

  constructor() {
    this.axiosInstance = axios.create({
      baseURL: `${import.meta.env.VITE_BASE_URL}/v1`,
    })
  }

  public async get<T>(url: string, options?: RequestOptions): Promise<T> {
    const configHeaders = options?.noAuth ? {} : await getAuthorizationHeader()

    const response = await this.axiosInstance.get(url, {
      headers: configHeaders,
    })

    return response.data
  }

  public async post<T>(url: string, data: unknown): Promise<T> {
    const configHeaders = await getAuthorizationHeader()
    const response = await this.axiosInstance.post(url, data, {
      headers: configHeaders,
    })

    return response.data
  }

  public async put<T>(url: string, data: unknown): Promise<T> {
    const configHeaders = await getAuthorizationHeader()
    const response = await this.axiosInstance.put(url, data, {
      headers: configHeaders,
    })

    return response.data
  }
}

const client = new RequestClient()

export { client }
